import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';
import { fetchTimesheetCategoriesDropdown } from 'actions';
import { isArray, isEmpty, map, find, isEqual } from 'lodash';
import { CustomDropdownContainer } from 'CommonComponent';

const TimesheetCategoryDropdown = ({
  selectedId = '',
  selectedChangingId = '',
  categoryValue,
  setCategoryValue,
  categoryOnChange,
  setAllCategoryIds,
  showSelectAllOption = true,
  isMulti = true,
  placeholder = 'Select Category',
  label = 'Category',
  name = 'category_id',
  error = '',
}) => {
  const dispatch = useDispatch();
  const session = useSelector((s) => s.session);
  const categoryList = useSelector((state) => state.timeSheetCategoryState.categoriesDropdownList);
  const [options, setOptions] = useState([]);

  useEffect(() => {
    dispatch(fetchTimesheetCategoriesDropdown(session?.current_page_permissions?.object_id || ''));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!selectedChangingId || !categoryList) return;

    if (isArray(selectedChangingId)) {
      const selected = selectedChangingId.map(id =>
        find(categoryList, ['id', id])
      ).filter(Boolean).map(item => ({ value: item.id, label: item.name }));
      setCategoryValue(selected);
    } else {
      const selected = find(categoryList, ['id', selectedChangingId]);
      setCategoryValue(selected ? { value: selected.id, label: selected.name } : null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedChangingId, categoryList]);


  useEffect(() => {
    if (!categoryList) return;

    const formattedOptions = map(categoryList, item => ({
      value: item.id,
      label: item.name
    }));

    if (showSelectAllOption && isMulti) {
      formattedOptions.unshift({ value: 'all', label: 'All' });
    }

    setOptions(formattedOptions);

    if (typeof setAllCategoryIds === 'function') {
      setAllCategoryIds(map(categoryList, 'id'));
    }

    if (!isEmpty(selectedId)) {
      if (isArray(selectedId)) {
        const selected = selectedId.map(id =>
          find(formattedOptions, ['value', id])
        ).filter(Boolean);

        if (!isEqual(categoryValue, selected)) {
          setCategoryValue(selected);
        }
      } else {
        const selected = find(formattedOptions, ['value', selectedId]);
        if (!isEqual(categoryValue, selected)) {
          setCategoryValue(selected || null);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categoryList, selectedId, isMulti, showSelectAllOption]);


  return (
    <>
      <Form.Group className="mb-3">
        <Form.Label className="label-input">{label}</Form.Label>
        <Select
          name={name}
          options={options}
          value={categoryValue}
          onChange={categoryOnChange}
          isMulti={isMulti}
          placeholder={placeholder}
          className="multi-select w-100"
          classNamePrefix="react-select"
          isSearchable
          components={{ ValueContainer: CustomDropdownContainer }}
        />
        {error && <div className="invalid-feedback d-block">{error}</div>}
      </Form.Group>
    </>
  );
};

TimesheetCategoryDropdown.propTypes = {
  categoryOnChange: PropTypes.func.isRequired,
  setCategoryValue: PropTypes.func.isRequired,
  categoryValue: PropTypes.any,
  selectedId: PropTypes.any,
  selectedChangingId: PropTypes.any,
  setAllCategoryIds: PropTypes.func,
  isMulti: PropTypes.bool,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  name: PropTypes.string,
  error: PropTypes.string,
};

export default TimesheetCategoryDropdown;
